import { Block, Tag, useStyletron } from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import mezoLogo from "#/assets/mezo-lockup.svg"
import {
  DASHBOARD_HEADER_HEIGHT,
  IS_MEZO_MAINNET,
  routes,
  SIDEBAR_NAVIGATION_WIDTH,
} from "#/shared/constants"

export default function DashboardHeaderLogo() {
  const [, theme] = useStyletron()

  return (
    <Block
      backgroundColor={theme.colors.white}
      width={SIDEBAR_NAVIGATION_WIDTH}
      height={`${DASHBOARD_HEADER_HEIGHT}px`}
      display="flex"
      alignItems="center"
      justifyContent="center"
      overrides={{ Block: { style: { gap: "12px", borderRight: "none" } } }}
    >
      <Link to={routes.OVERVIEW}>
        <Block as="img" src={mezoLogo} alt="Mezo" />
      </Link>

      {!IS_MEZO_MAINNET && (
        <Tag
          closeable={false}
          color="yellow"
          size="small"
          overrides={{
            Root: {
              style: { margin: 0 },
            },
          }}
        >
          Testnet
        </Tag>
      )}
    </Block>
  )
}
